export const reviewerRoutes = [{
        path: '/reviewers',
        name: 'Reviewers',
        meta: {
            requiresAuth: true,
            accessId: 'reviewers',
        },
        component: () =>
            import ('../views/reviewerList.vue')
    },
    {
        path: '/reviewer/create',
        name: 'reviewerCreate',
        meta: {
            requiresAuth: true,
            accessId: 'reviewers',
        },
        component: () =>
            import ('../views/reviewerCreate.vue')
    },
    {
        path: '/reviewer/edit/:reviewerId',
        name: 'reviewerEdit',
        props: true,
        meta: {
            requiresAuth: true,
            accessId: 'reviewers',
        },
        component: () =>
            import ('../views/reviewerEdit.vue')
    },
    {
        path: '/reviewer/view/:reviewerId',
        name: 'reviewerView',
        props: true,
        meta: {
            requiresAuth: true,
            accessId: 'reviewers',
        },
        component: () =>
            import ('../views/reviewerView.vue')
    },
]